import React from "react";
import {Container} from "../containers/Container";
import {Hero, HeroBody, HeroHeading2} from "../text";
import {CheckmarkIcon, CloseIcon} from "../icons";

export const UpgradeLandingFeaturesSectionView: React.FC<any> = () => {
  const features: { id: string, title: string, isPremiumFeature: boolean, isFreeFeature: boolean }[] = [
    { id: 'basic_macro_tracking', title: 'Basic macro tracking', isPremiumFeature: true, isFreeFeature: true },
    { id: 'diet_coach', title: 'Weekly diet coach to optimize your plan', isPremiumFeature: true, isFreeFeature: false },
    { id: 'meal_plans', title: 'Meal plans that fit your macros', isPremiumFeature: true, isFreeFeature: false },
    { id: 'daily_macros', title: 'Carb-cycling & refeeds with daily macro goals', isPremiumFeature: true, isFreeFeature: false },
    { id: 'track_micros', title: 'Track and set goals for vitamins & minerals', isPremiumFeature: true, isFreeFeature: false },
    { id: 'create_meals', title: 'Create your own meals & recipes', isPremiumFeature: true, isFreeFeature: false },
    { id: 'recipes', title: 'Access to 400+ macro-friendly recipes', isPremiumFeature: true, isFreeFeature: false },
    { id: 'custom_log', title: 'Customize your meal sections', isPremiumFeature: true, isFreeFeature: false },
    { id: 'quick_add', title: 'Quickly add macro estimates to your log', isPremiumFeature: true, isFreeFeature: false },
    { id: 'edit_foods', title: 'Edit nutrition info for foods in our database', isPremiumFeature: true, isFreeFeature: false },
  ]

  return <Container className="flex flex-col max-w-screen-lg">
    <Hero className="text-center">
      What&apos;s in <span className="text-fg-primary font-bold">Premium?</span>
    </Hero>

    <div className={`w-full grid grid-cols-17 sm:grid-cols-6 gap-x-4 content-center px-6 lg:px-8 py-4 lg:py-6`}>
      <div className="col-span-9 sm:col-span-4" />
      <HeroHeading2 className="col-span-4 sm:col-span-1 text-center">Free</HeroHeading2>
      <HeroHeading2 className="col-span-4 sm:col-span-1 text-center">Premium</HeroHeading2>
    </div>

    {features.map((feature, index) => {
      const isEven = index % 2 === 0
      return <div key={feature.id} className={`w-full grid grid-cols-17 sm:grid-cols-6 gap-x-4 content-center px-6 lg:px-10 py-4 lg:py-8 rounded-xl ${isEven ? '' : 'bg-fg-gray-surface'}`}>
        <HeroBody className="col-span-9 sm:col-span-4">{feature.title}</HeroBody>
        <div className="flex col-span-4 sm:col-span-1 items-center justify-center">
          {feature.isFreeFeature ? <CheckmarkIcon className="h-6 w-6 text-fg-primary" /> : <CloseIcon className="h-6 w-6 text-fg-gray" />}
        </div>
        <div className="flex col-span-4 sm:col-span-1 items-center justify-center">
          {feature.isPremiumFeature ? <CheckmarkIcon className="h-6 w-6 text-fg-primary" /> : <CloseIcon className="h-6 w-6 text-fg-gray" />}
        </div>
      </div>
    })}
  </Container>
}